import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const additionalChargesAdapter = getAdapter();

const additionalChargesSlice = createSlice({
  name: 'additionalCharges',
  initialState: additionalChargesAdapter.getInitialState(),
  reducers: {
    setAdditionalCharges: (state, { payload: { additionalCharges } }) => {
      additionalChargesAdapter.setAll(state, additionalCharges);
    },
  },
});

const selectors = additionalChargesAdapter.getSelectors(({ additionalCharges }) => additionalCharges);

export const getAdditionalChargesIncludingDeleted = (state) => selectors.selectAll(state);

export const getAdditionalCharges = (state) =>
  getAdditionalChargesIncludingDeleted(state).filter(({ deleted }) => !deleted);

export const { setAdditionalCharges } = additionalChargesSlice.actions;

export default additionalChargesSlice.reducer;
